import { render, staticRenderFns } from "./AddCamera.vue?vue&type=template&id=8a83416e&scoped=true"
import script from "./AddCamera.vue?vue&type=script&lang=js"
export * from "./AddCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a83416e",
  null
  
)

export default component.exports